<div  class="flex flex-col flex-auto overflow-y-auto lg:overflow-hidden bg-card dark:bg-default">
    <div
        class="flex flex-col flex-auto flex-shrink-0 lg:flex-shrink p-3 lg:overflow-y-auto bg-gray-100 dark:bg-transparent"
        fuseScrollReset>
        <div
            class="flex flex-col flex-0 w-full shadow rounded-2xl overflow-hidden bg-card dark:bg-black dark:bg-opacity-10">

            <div class="flex flex-col py-8 px-6">

                <div class="col-md-12" *ngIf="paso?.ui !== 'terminos-condiciones'">
                    <span evkMatHeadLine>{{paso.titulo}}</span>
                </div>

                <!-- Datos generales -->
                <lib-datos-generales *ngIf="paso?.ui == 'general'" [form]="form"></lib-datos-generales>

                <!-- Formulario dinamico con paginador -->
                <contenedor-base (actualizar)="onSelectionChangedList($event)"
                                 [config]="paso" [listaElementos]="listaAlmacenada"
                                 [readOnly]="readOnly"
                                 *ngIf="paso?.ui === 'metadata' && paso?.cardinalidad === '*'">

                    <!--
                        Aqui van las bandejas custom, el idBandeja se registra en archivo excel en la seccion SeccionExpedienteConfig
                    -->
                    <bandeja-datos-de-soporte [config]="paso" [readOnly]="readOnly" *ngIf="paso?.idBandeja === 'datosDeSoporte'"></bandeja-datos-de-soporte>
                    <bandeja-dias-festivos [config]="paso" [readOnly]="readOnly" *ngIf="paso?.idBandeja === 'diasFestivos'"></bandeja-dias-festivos>
                    <bandeja-slas [config]="paso" [readOnly]="readOnly" *ngIf="paso?.idBandeja === 'slas'"></bandeja-slas>
                    <bandeja-niveles-criticidad [config]="paso" [readOnly]="readOnly" *ngIf="paso?.idBandeja === 'nivelesCriticidad'"></bandeja-niveles-criticidad>

                </contenedor-base>

                <!-- Formulario dinamico -->
                <seaged-form-factory *ngIf="paso?.ui == 'metadata' && paso?.cardinalidad !== '*'" [form]="form"
                                     [idNegocio]="paso?.metadataFormId"
                                     [actionsFields]="this.actionsField"
                                     (onDoneForm)="onDoneForm($event)"></seaged-form-factory>

                <!--
                    COMPONENTES DETALLE DE EXPEDIENTES
                    Agregar elemento en ExpedientesWizardComponent.agregarDetalle
                -->

                <lib-expediente-detalle
                    [expediente]="paso?.inData?.expediente"
                    [expedienteConfig]="paso?.inData?.expedienteConfig"
                    *ngIf="paso?.ui === 'detalle'">
                </lib-expediente-detalle>

                <lib-diligencia-detalle
                    [expediente]="paso?.inData?.expediente"
                    [expedienteConfig]="paso?.inData?.expedienteConfig"
                    *ngIf="paso?.ui === 'detalle-diligencia'">
                </lib-diligencia-detalle>


                <!--
                    COMPONENTES CUSTOM EN WIZARDS
                    En excel SeccionExpedienteConfig en columna seccion ingresar nombre de seccion en mayusculas
                    Crear componente en la carpeta wizard/componentes/section/sub-components
                    En proyecto de expedientes en enum EnumSeccion agregar el nombre de la seccion y el selector del componente de angular
                    Agregar ui el elemento HTML


                -->



                <!--Componentes Mapas -->
                <mapas-container *ngIf="paso?.ui === 'georeferencia'"
                                 [config]= "paso" [paso]= "paso">
                </mapas-container>

                <evomatik-google-maps *ngIf="paso?.ui === 'evk-google-maps'" [config]="paso" [paso]="paso">
                </evomatik-google-maps>

                <!--Componentes Mapas -->

                <lib-biometricos-biosphere
                    *ngIf="paso?.ui === 'biometricos'"
                    [config]="paso"
                    [biosphereConfig]="biosphereConfig"
                    >
                </lib-biometricos-biosphere>

                <lib-documentos *ngIf="paso?.ui === 'documentos-proyecto'"
                    [expediente]="paso?.inData?.expediente"
                    [expedienteConfig]="paso?.inData?.expedienteConfig"
                    [config]="paso"
                    [descargaZipByFolio]="descargaZipByFolio"
                    [skipByVersion]="skipByVersion"
                    [readOnly]="readOnly"
                    (adjuntandoDocumentos)="validarAdjuntando($event)">
                </lib-documentos>

                <lib-terminos-condiciones
                    *ngIf="paso?.ui === 'terminos-condiciones'"
                    [config]="paso"
                    [form]="form">
                </lib-terminos-condiciones>

                <lib-generacion-requerimiento
                    *ngIf="paso?.ui === 'generacion-requerimiento'"
                    [config]="paso">
                </lib-generacion-requerimiento>

                <lib-solicitud-firma
                    *ngIf="paso?.ui === 'solicitud-firma'"
                    [expediente]="paso?.inData?.expediente"
                    [config]="paso">
                </lib-solicitud-firma>

                <lib-solicitud-pago
                    *ngIf="paso?.ui === 'solicitud-pago'"
                    [expediente]="paso?.inData?.expediente"
                    (resultObject)="onDoneForm($event)"
                    [config]="paso">
                </lib-solicitud-pago>

                <validacion-codigo
                    *ngIf="paso?.ui === 'validacion-codigo'"
                    [config]="paso">
                </validacion-codigo>

                <confirmacion-registro
                    *ngIf="paso?.ui === 'confirmacion-registro'"
                    [config]="paso">
                </confirmacion-registro>


                <lib-directorio-oficinas
                    *ngIf="paso?.ui === 'directorio-oficinas'">
                </lib-directorio-oficinas>
            </div>
        </div>
    </div>
</div>
